import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { auth } from "../../db/config";

export default function Slider() {
  const [user, setuser] = useState(false);
  useEffect(() => {
    auth.onAuthStateChanged((user) => {
      if (user.uid) {
        setuser(true);
      } else {
        setuser(false);
      }
    });
  }, []);
  return (
    <div>
      <div class="slider-area float_left">
        <div class="banner_img_top">
          <img src="images/banner.png" alt="img" />
        </div>

        <div
          id="carousel-example-generic"
          class="carousel slide"
          data-ride="carousel"
        >
          <div class="carousel-inner" role="listbox">
            <div class="carousel-item active">
              <div class="carousel-captions caption-1">
                <div class="container">
                  <div class="row">
                    <div class="col-xl-7 col-lg-7 col-md-12 col-sm-12 col-12">
                      <div class="content">
                        <h2 data-animation="animated bounceInUp">
                          You need profits?
                          <br />
                          we know profits.
                        </h2>

                        <h3 data-animation="animated bounceInUp">
                          Invest Your Money <br />
                          For Future
                        </h3>

                        <div class="slider_btn float_left">
                          <ul>
                            {user ? (
                              ""
                            ) : (
                              <li data-animation="animated bounceInLeft">
                                <a href="/register">start now</a>
                              </li>
                            )}
                            <li data-animation="animated bounceInLeft">
                              <a href="/investment">view plans</a>
                            </li>
                          </ul>
                        </div>
                        <div class="clear"></div>
                      </div>
                    </div>
                    <div class="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-12">
                      <div class="slider_main_img_wrapper">
                        <img src="images/slider_img.png" alt="slider_img" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="carousel-item">
              <div class="carousel-captions caption-2">
                <div class="container">
                  <div class="row">
                    <div class="col-xl-7 col-lg-7 col-md-12 col-sm-12 col-12">
                      <div class="content">
                        <h2 data-animation="animated bounceInLeft">
                          Often Have Small
                        </h2>

                        <h3 data-animation="animated bounceInLeft">
                          Invest Your Money <br />
                          For Future
                        </h3>

                        <div class="slider_btn float_left">
                          <ul>
                            {user ? (
                              ""
                            ) : (
                              <li data-animation="animated bounceInLeft">
                                <a href="/register">start now</a>
                              </li>
                            )}

                            <li data-animation="animated bounceInLeft">
                              <a href="/investement">view plans</a>
                            </li>
                          </ul>
                        </div>
                        <div class="clear"></div>
                      </div>
                    </div>
                    <div class="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-12">
                      <div class="slider_main_img_wrapper">
                        <img src="images/slider_img.png" alt="slider_img" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="carousel-item">
              <div class="carousel-captions caption-3">
                <div class="container">
                  <div class="row">
                    <div class="col-xl-7 col-lg-7 col-md-12 col-sm-12 col-12">
                      <div class="content">
                        <h2 data-animation="animated bounceInLeft">
                          Often Have Small
                        </h2>

                        <h3 data-animation="animated bounceInLeft">
                          Invest Your Money <br />
                          For Future
                        </h3>

                        <div class="slider_btn float_left">
                          <ul>
                            {user ? (
                              ""
                            ) : (
                              <li data-animation="animated bounceInLeft">
                                <a href="/register">start now</a>
                              </li>
                            )}
                            <li data-animation="animated bounceInLeft">
                              <a href="/investement">view plans</a>
                            </li>
                          </ul>
                        </div>
                        <div class="clear"></div>
                      </div>
                    </div>
                    <div class="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-12">
                      <div class="slider_main_img_wrapper">
                        <img src="images/slider_img.png" alt="slider_img" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <ol class="carousel-indicators">
              <li
                data-target="#carousel-example-generic"
                data-slide-to="0"
                class="active"
              >
                <span class="number"></span>
              </li>
              <li
                data-target="#carousel-example-generic"
                data-slide-to="1"
                class=""
              >
                <span class="number"></span>
              </li>
              <li
                data-target="#carousel-example-generic"
                data-slide-to="2"
                class=""
              >
                <span class="number"></span>
              </li>
            </ol>
            <div class="carousel-nevigation">
              <a
                class="prev"
                href="#carousel-example-generic"
                role="button"
                data-slide="prev"
              >
                {" "}
                <span></span> <i class="flaticon-left-arrow"></i>
              </a>
              <a
                class="next"
                href="#carousel-example-generic"
                role="button"
                data-slide="next"
              >
                {" "}
                <span></span> <i class="flaticon-arrow-pointing-to-right"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
